

import { useState, useRef, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import './App.css';
import Home from './components/Home';
import Wildlife from './components/Wildlife';
import Footer from './components/Footer';
import ServicesPage from './components/Services';
import ContactUs from './components/Contactus';
import Booking from './components/Booking';
import AboutUs from './components/AboutUs';
import Destinations from './components/Destinations';

// Providers
import { QueryProvider } from './providers/QueryProvider';
import { AuthProvider } from './contexts/AuthContext';
import { Toaster } from 'react-hot-toast';

// Destination Components
import Serengeti from './components/serengeti';
import Ngorongoro from './components/Ngorongoro';
import Tarangire from './components/Tarangire';
import Manyara from './components/Manyara';

import TwelveDays from './components/12days';
import SerengentiSafari from './components/9days';
import NineDaysTanzania from './components/7days';
import SixDaysSafari from './components/6days';
import FiveDaysSafari from './components/5days';

import FiveDaysBestSafari from './components/5daysbest';
import FourDays from './components/4days';
import ThreeDaySerengeti from './components/3dayserengenti';
import SerengetiNgorongoro from './components/serengetingorongoro';
import TarangireNgorongoro from './components/tangirengorongoro';
import TarangireOneDay from './components/tarangire1day'; 

import ZanzibarHoneymoon from './components/zanzibarhoneymoon';
import ZanzibarIsland from './components/zanzibarisland';
import PrisonMnembaZanzibar from './components/prisonmnemba';
import ZanzibarTour from './components/6daytour';
import ZanzibarSafariBlue from './components/ZanzibarSafariBlue';
import ZanzibarTour2 from './components/ZanzibarStoneTown';

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const topBarRef = useRef(null);
  const navbarRef = useRef(null);
  const contentRef = useRef(null);

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  useEffect(() => {
    const updatePositions = () => {
      if (topBarRef.current && navbarRef.current && contentRef.current) {
        const topBarHeight = topBarRef.current.offsetHeight;
        const navbarHeight = navbarRef.current.offsetHeight;
        navbarRef.current.style.top = `${topBarHeight}px`;
        contentRef.current.style.marginTop = `${topBarHeight + navbarHeight}px`;
      }
    };

    updatePositions();
    window.addEventListener('resize', updatePositions);
    return () => window.removeEventListener('resize', updatePositions);
  }, []);

  return (
    <>


      <QueryProvider>
        <AuthProvider>
          <Router>
            <div className="App font-body">
              {/* Top Bar */}
              <div className="top-bar" ref={topBarRef}>
                <div className="social-icons">
                  <a href="https://www.facebook.com/africanadventures" target="_blank" rel="noopener noreferrer" title="Facebook">
                    <i className="fab fa-facebook-f"></i>
                  </a>
                  <a href="https://x.com/Africana2011" target="_blank" rel="noopener noreferrer" title="Twitter">
                    <i className="fab fa-twitter"></i>
                  </a>
                  <a href="https://youtube.com/@adventure-travellers?si=jLaAqw3jLZsVepY4" target="_blank" rel="noopener noreferrer" title="YouTube">
                    <i className="fab fa-youtube"></i>
                  </a>
                  <a href="https://www.instagram.com/african_adventures?igsh=YzljYTk1ODg3Zg==" target="_blank" rel="noopener noreferrer" title="Instagram">
                    <i className="fab fa-instagram"></i>
                  </a>
                </div>
                
                <div className="contact-info">
                  <a href="tel:+255753182737" className="contact-item font-body">
                    <i className="fas fa-phone"></i>
                    <span>+255 753 182 737</span>
                  </a>
                  <a href="mailto:safaris@tanzania-yetutravellers.com" className="contact-item font-body">
                    <i className="fas fa-envelope"></i>
                    <span>safaris@tanzania-yetutravellers.com</span>
                  </a>
                </div>
              </div>

              {/* Main Navigation */}
              <nav className="navbar" ref={navbarRef}>
                <div className="logo">
                  <img src="/aat logo 2.png" alt="Tanzania Yetu Logo" className="logo-image" />
                </div>
                
                <div className="nav-container">
                  <div className="hamburger" onClick={() => setIsMenuOpen(!isMenuOpen)}>
                    <i className={`fas ${isMenuOpen ? 'fa-times' : 'fa-bars'}`}></i>
                  </div>
                  <ul className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
                    <li><Link to="/" onClick={closeMenu} className="font-nav">Home</Link></li>
                    <li><Link to="/AboutUs" onClick={closeMenu} className="font-nav">About Us</Link></li>
                    <li><Link to="/services" onClick={closeMenu} className="font-nav">Our Gallery</Link></li>
                    <li><Link to="/wildlife" onClick={closeMenu} className="font-nav">Wildlife</Link></li>
                    <li><Link to="/contact" onClick={closeMenu} className="font-nav">Contact Us</Link></li>
                    <li><Link to="/destinations" onClick={closeMenu} className="font-nav">Destinations</Link></li>
                    <li><Link to="/booking" onClick={closeMenu} className="font-nav">Booking</Link></li>
                  </ul>
                </div>
              </nav>

              {/* Mobile Menu Overlay */}
              {isMenuOpen && (
                <div 
                  className="menu-overlay" 
                  onClick={closeMenu}
                  style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    zIndex: 998,
                    cursor: 'pointer'
                  }}
                ></div>
              )}

              <div className="content-wrapper" ref={contentRef}>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/AboutUs" element={<AboutUs />} />
                  <Route path="/wildlife" element={<Wildlife />} />
                  <Route path="/services" element={<ServicesPage />} />
                  <Route path="/contact" element={<ContactUs />} />
                  <Route path="/booking" element={<Booking />} />
                  <Route path="/destinations" element={<Destinations />} />

                  {/* Destination Routes */}
                  <Route path="/destinations/serengeti" element={<Serengeti />} />
                  <Route path="/destinations/Ngorongoro" element={<Ngorongoro />} />
                  <Route path="/destinations/Tarangire" element={<Tarangire />} />
                  <Route path="/destinations/Manyara" element={<Manyara />} />

                  <Route path="/destinations/12days" element={<TwelveDays />} />
                  <Route path="/destinations/9days" element={<SerengentiSafari />} />
                  <Route path="/destinations/7days" element={<NineDaysTanzania />} />
                  <Route path="/destinations/6days" element={<SixDaysSafari />} />
                  <Route path="/destinations/5days" element={<FiveDaysSafari />} />

                  <Route path="/destinations/5daysbest" element={<FiveDaysBestSafari />} />
                  <Route path="/destinations/4days" element={<FourDays />} /> 
                  <Route path="/destinations/3dayserengenti" element={<ThreeDaySerengeti />} />
                  <Route path="/destinations/serengetingorongoro" element={<SerengetiNgorongoro />} />
                  <Route path="/destinations/Tangirengorongoro" element={<TarangireNgorongoro />} />
                  <Route path="/destinations/tarangire1day" element={<TarangireOneDay />} />

                  {/* Zanzibar Routes */}
                  <Route path="/destinations/zanzibarhoneymoon" element={<ZanzibarHoneymoon />} />
                  <Route path="/destinations/zanzibarisland" element={<ZanzibarIsland />} />
                  <Route path="/destinations/prisonmnemba" element={<PrisonMnembaZanzibar />} />
                  <Route path="/destinations/6daytour" element={<ZanzibarTour />} />
                  <Route path="/destinations/ZanzibarSafariBlue" element={<ZanzibarSafariBlue />} />
                  <Route path="/destinations/ZanzibarStoneTown" element={<ZanzibarTour2 />} />
                </Routes>
                <Footer />
              </div>
            </div>
            <Toaster position="top-right" />
          </Router>
        </AuthProvider>
      </QueryProvider>
    </>
  );
}

export default App;